import {
  SET_ORIGIN,
  SET_REDIRECT_URL,
  SET_PUBLICKEY,
  SET_IS_CITA_FLOW,
  SET_BUTTON_URL,
  SET_CUSTOMER_ID,
  SET_CART_COUNTRY,
  SET_APPOINTMENT_DATE,
  SET_APPOINTMENT_CENTER,
} from '../types';

export default (state, action) => {
  switch (action.type) {
    case SET_ORIGIN:
      return {
        ...state,
        origin: action.payload,
      };
    case SET_REDIRECT_URL:
      return {
        ...state,
        redirectUrl: action.payload,
      };
    case SET_PUBLICKEY:
      return {
        ...state,
        publicKey: action.payload,
      };
    case SET_IS_CITA_FLOW:
      return {
        ...state,
        isCitaFlow: action.payload,
      };
    case SET_BUTTON_URL:
      return {
        ...state,
        buttonUrl: action.payload,
      };
    case SET_CUSTOMER_ID:
      return {
        ...state,
        customerId: action.payload,
      };
    case SET_CART_COUNTRY:
      return {
        ...state,
        country: action.payload,
      };
    case SET_APPOINTMENT_DATE:
      return {
        ...state,
        appointmentDate: action.payload,
      };
    case SET_APPOINTMENT_CENTER:
      return {
        ...state,
        appointmentCenter: action.payload,
      };
    default:
      return state;
  }
};
